import React from "react";
import { Space } from "antd";
import { AxButton, AxMessage, AxDivider } from "@dynata/axiom3";

const normal = () => {
  AxMessage.show({
    content: "Normal message",
    type: "normal",
    duration: 20,
  });
};

const success = () => {
  AxMessage.show({
    content: "Success message",
    type: "success",
    duration: 3,
  });
};

const error = () => {
  AxMessage.show({
    content: "Error message",
    type: "error",
    duration: 3,
  });
};

const warning = () => {
  AxMessage.show({
    content: "Warning message",
    type: "warning",
    duration: 3,
  });
};

const loading = () => {
  AxMessage.show({
    content: "Loading ...",
    type: "loading",
    duration: 5,
  });
};

class Message extends React.Component {
  render() {
    return (
      <div className="section" id="message">
        <h3>Message</h3>
        <p>
          Display global messages as feedback in response to user operations.
        </p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space direction="vertical">
          <Space size="large" direction="vertical">
            <pre>{`AxMessage.show({
  content: "Success Message",
  type: "success",
});`}</pre>
            <div className="prop-header">
              <p className="props-title">Props</p>
              <p>
                For AntD props, visit{" "}
                <AxButton
                  size="small"
                  type="link"
                  target="_blank"
                  href="https://ant.design/components/message/#API"
                >
                  https://ant.design/components/message/#API
                </AxButton>
              </p>
            </div>

            <table className="props-table">
              <thead>
                <tr>
                  <th>Argument</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>type</td>
                  <td>Predefined types</td>
                  <td>normal | success | warning | error | loading</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>content</td>
                  <td>The content of the message</td>
                  <td>string</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>duration</td>
                  <td>
                    Time (seconds) before auto-dismiss, don't dismiss if set to
                    0
                  </td>
                  <td>number</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>duration</td>
                  <td>Time before auto-dismiss, in seconds</td>
                  <td>number</td>
                  <td>3</td>
                  <td></td>
                </tr>
                <tr>
                  <td>getContainer</td>
                  <td>Return the mount node for Message</td>
                  <td>() =&gt; HTMLElement</td>
                  <td>
                    <code>{`() =&gt; document.body`}</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>maxCount</td>
                  <td>Max message show, drop oldest if exceed limit</td>
                  <td>number</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>prefixCls</td>
                  <td>The prefix className of message node</td>
                  <td>string</td>
                  <td>
                    <code>ant-message</code>
                  </td>
                  <td>4.5.0</td>
                </tr>
                <tr>
                  <td>rtl</td>
                  <td>Whether to enable RTL mode</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>top</td>
                  <td>Distance from top</td>
                  <td>number</td>
                  <td>8</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <pre>{`
const normal = () => {
  AxMessage.show({
    content: "Normal message",
    type: "normal",
    duration: 20,
  });
};

const success = () => {
  AxMessage.show({
    content: "Success message",
    type: "success",
    duration: 3,
  });
};

const error = () => {
  AxMessage.show({
    content: "Error message",
    type: "error",
    duration: 3,
  });
};

const warning = () => {
  AxMessage.show({
    content: "Warning message",
    type: "warning",
    duration: 3,
  });
};

const loading = () => {
  AxMessage.show({
    content: "Loading ...",
    type: "loading",
    duration: 5,
  });
};

<AxButton type="primary" onClick={normal}>
  Normal
</AxButton>
<AxButton type="primary" onClick={warning}>
  Warning
</AxButton>
<AxButton type="primary" onClick={success}>
  Success
</AxButton>
<AxButton type="primary" onClick={error}>
  Error
</AxButton>
<AxButton type="primary" onClick={loading}>
  Loading
</AxButton>
`}</pre>
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          Normal | Warning | Success | Error | Loading
        </AxDivider>

        <Space size="large">
          <AxButton type="primary" onClick={normal}>
            Normal
          </AxButton>
          <AxButton type="primary" onClick={warning}>
            Warning
          </AxButton>
          <AxButton type="primary" onClick={success}>
            Success
          </AxButton>
          <AxButton type="primary" onClick={error}>
            Error
          </AxButton>
          <AxButton type="primary" onClick={loading}>
            Loading
          </AxButton>
        </Space>
      </div>
    );
  }
}
export default Message;
